const isProductionEnvironment = () => {
    const isProduction = sessionStorage.getItem('isProduction');
    return isProduction && isProduction === 'true';
}

export {isProductionEnvironment}